import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import dayjs from 'core/utils/dayjs';
import { selectCurrentDate } from 'core/selectors/env';

export const selectInstoreCuratedOffersContent = state => state.instoreCuratedOffersContent;
const selectInstoreLinkCardInfo = state => state.cardLinkOffer;

export const selectInstoreCuratedOffersContentIsLoading = createSelector(
  selectInstoreCuratedOffersContent,
  ({ isLoading }) => isLoading,
);

export const selectInstoreCuratedOffersContentIsLoaded = createSelector(
  selectInstoreCuratedOffersContent,
  ({ isLoaded }) => isLoaded,
);

export const selectInstoreCuratedOffers = createSelector(
  selectInstoreCuratedOffersContent,
  ({ offers }) => offers,
);

export const selectInstoreCuratedOffersPlacements = createSelector(
  [
    selectInstoreCuratedOffers,
    selectInstoreLinkCardInfo,
    selectCurrentDate,
  ],
  (offers, cardLinkOffer, currentDate) => {
    const { isLoaded, linkedCardResponse } = cardLinkOffer;
    const offerCopy = [...offers];
    if (isLoaded && linkedCardResponse && linkedCardResponse.length) {
      offerCopy.map((offer) => {
        let daysToExpire = null;
        linkedCardResponse.map((linkedCard) => {
          if (!linkedCard.error) {
            const { eligibleCards } = offer;
            const { paymentCard, error, expirationDate } = linkedCard;
            const { cardId } = paymentCard;

            if (error) {
              offer.showError = true;
            }

            if (offer.offerId && linkedCard.offerId && offer.offerId ===
              linkedCard.offerId && !error) {
              paymentCard.linkExpirationDate = dayjs(expirationDate).format();
              offer.eligibleCards = filter(eligibleCards,
                (card) => card.cardId !== cardId);
              offer.linkedCards.push(paymentCard);
              offer.linked = true;
            }
          }

          return linkedCard;
        });

        offer.linkedCards.forEach(card => {
          const linkCardExpiryDate = dayjs(card.linkExpirationDate);
          const expiryDays = linkCardExpiryDate.diff(currentDate, 'days');

          if (daysToExpire === null || daysToExpire > expiryDays) {
            daysToExpire = expiryDays;
          }
        });

        offer.daysToExpire = daysToExpire;

        return offer;
      });
    }
    return offerCopy;
  },
);

export const selectInstoreCuratedOffersHeading = state => state.instoreCuratedOffersHeading;

export const selectInstoreCuratedOffersHeadingIsLoading = createSelector(
  selectInstoreCuratedOffersHeading,
  ({ isLoading }) => isLoading,
);

export const selectInstoreCuratedOffersHeadingIsLoaded = createSelector(
  selectInstoreCuratedOffersHeading,
  ({ isLoaded }) => isLoaded,
);

export const selectInstoreCuratedOffersHeadingData = createSelector(
  selectInstoreCuratedOffersHeading,
  ({ data }) => data,
);
